import React, { useMemo } from 'react';
import BaseSidePanel from 'components/sidePanel/baseSidePanel';
import { ITabItem } from 'components/tab';
import IngredientInfo from '../IngredientInfo/IngredientInfo';
import RequiredStock from '../RequiredStock/RequiredStock';
import ImageInfo from './ImageInfo';
import { useRMSelector } from 'redux/hooks';
import { selectExp } from 'redux/selectors/ExperimentStateSelector';
import PlateInfo from '../PlateInfo/PlateInfo';
import useRMLite from 'CustomHooks/useRMLite';
import { useLastSelectedWellNavigationDetails } from 'redux/hooks/experiment';

let tabItems_: ITabItem[] = [
  {
    title: 'Ingredient Info',
    content: <IngredientInfo />,
    iconProps: { name: 'IngredientInfo' },
  },
  {
    title: 'Required Stock',
    content: <RequiredStock />,
    iconProps: { name: 'IngredientStocks' },
  },
  {
    title: 'Image Info',
    content: <ImageInfo />,
    iconProps: { name: 'ImageManage' },
  },
  {
    title: 'Plate Info',
    content: <PlateInfo />,
    iconProps: { name: 'PlateInfo' },
  },
];

const ExperimentDashboardInfoPanel = ({ isOpenFromScreen = false }) => {
  const rmLite = useRMLite();
  if (isOpenFromScreen) {
    tabItems_ = tabItems_.filter((x) => x.title !== 'Image Info');
  }
  if (rmLite) {
    tabItems_ = tabItems_.filter((x) => x.title !== 'Required Stock');
  }
  const exp = useRMSelector(selectExp);
  const wellNavigationDetails = useLastSelectedWellNavigationDetails();
  const plateID = wellNavigationDetails?.plateID;
  const plateName = useMemo(() => {
    if (!exp.plateDto) {
      return;
    }
    const plate = exp.plateDto.find((pl) => pl.plateId === plateID);
    if (plate === null || plate === undefined) {
      return exp.plateDto[0].plateBarName;
    }
    return plate.plateBarName;
  }, [exp.plateDto, plateID]);
  return (
    <BaseSidePanel
      id={`commandpanel-expdashboardinfo-panel-plate`}
      tabItems={tabItems_}
      headerTitle={plateName}
      headerIconProps={{ name: 'Plate' }}
    />
  );
};
export default ExperimentDashboardInfoPanel;
